import React from 'react';
import { useChatMentions } from './ChatMentionsProvider';

export const ChatMentionBadge = ({ prefix }) => {
  const { unread_count: count } = useChatMentions();
  return count ? <span className="chat-mention-badge" role="status" aria-label={`${count} unread chat mention${count === 1 ? '' : 's'}`} data-testid={`${prefix}-chat-mention-count`}>{count > 99 ? '99+' : count}</span> : null;
};